<mat-form-field class="allwidth">
  <mat-label>{{ 'IBAN' | translate}}</mat-label>
    <input matInput [value]="selectedPartnerIban?.IBAN" [disabled]="true" class="one">
    <i matSuffix *ngIf="ngControl?.control.enabled" class="glyphicon glyphicon-new-window link" (click)="selectPartnerIban()"></i>
</mat-form-field>
<error [control]="ngControl?.control"></error>
